import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- entities
import PayinList from 'PMT/entities/PayinList';
import Payin from 'PMT/entities/Payin';

// -- objects
import PayinsForTable from '../../../../objects/PayinsForTable';

// -- components
import AbstractComponent from 'components/AbstractComponent';
import PayinsTableView from './PayinsTableView';

/**
 * @parent ReceiptPage
 */
export default class PayinsView extends AbstractComponent {

  static propTypes = {
    payinList: PropTypes.instanceOf(PayinList).isRequired,
    currencyCode: PropTypes.string,

  };

  renderNoData(): Object {
    // no information to display

    return (
      <div className="payment_payins__no_data">
        <div className="col-xs-6 col-xs-offset-3 text-center">
          <i className="icon-smiley-down" />
          <p className="top-buffer-30">
            {I18n.tr('payins.no_payins')}
          </p>
        </div>
      </div>
    );
  }

  renderPayins(payinList:PayinList): Object {
    const groupedPayinsDic = {};
    payinList.payins.forEach((payin:Payin) => {

      if (_.isUndefined(groupedPayinsDic[payin.checkId])) {
        groupedPayinsDic[payin.checkId] = new PayinsForTable();
      }

      if (groupedPayinsDic[payin.checkId].date < payin.date) {
        groupedPayinsDic[payin.checkId].date = payin.date;
      }

      groupedPayinsDic[payin.checkId].checkId = payin.checkId;

      // Update check info
      groupedPayinsDic[payin.checkId].totalTable = payin.totalTable;
      groupedPayinsDic[payin.checkId].amount += payin.amount + payin.tips;
      groupedPayinsDic[payin.checkId].tips += payin.tips;
      groupedPayinsDic[payin.checkId].fees += payin.amount + payin.tips - payin.fees;

      // Add the payin to the check
      groupedPayinsDic[payin.checkId].payins.push(payin);
    });

    // -- transform to array
    let groupedPayins: Array<PayinsForTable> = [];

    for (const key in groupedPayinsDic) {
      groupedPayins.push(groupedPayinsDic[key]);
    }

    // -- Calculate totals
    let totalAmount = 0;
    let totalTips = 0;
    let totalFees = 0;
    let totalTable = 0;

    groupedPayins.forEach((payinsForTable: PayinsForTable) => {
      totalFees += payinsForTable.fees;
      totalTable += payinsForTable.amount;
      totalAmount += payinsForTable.amount + payinsForTable.tips;
      totalTips += payinsForTable.tips;
    });

    // -- View
    return (
      <div className="payment_payins__data">
        <PayinsTableView
          payins={groupedPayins}
          totalAmount={totalAmount}
          totalTips={totalTips}
          totalFees={totalFees}
          totalTable={totalTable}
          currencyCode={this.props.currencyCode}
        />
      </div>
    );
  }

  render(): Object {
    const payinList: PayinList = this.props.payinList;

    let contentView = (null);
    if (!_.isEmpty(payinList.payins)) {
      contentView = this.renderPayins(payinList);
    } else {
      contentView = this.renderNoData();
    }

    return (
      <div className="payment_payins">
        {contentView}
      </div>
    );
  }

}
